import { useAppSelector } from 'store/store';
import { BottomFromOperatorRoles } from 'shared/permissions/roles';

export function IsBottomFromOperator({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups?.some((role) => BottomFromOperatorRoles.includes(role))) return children;
}
